import React, { useState } from "react";
import styled from "styled-components";
import Spacer from "../Spacer";
import Check from "assets/icons/check2.svg";
import plus from "assets/icons/plus_secondary.svg";
import ImgWrapper from "../ImgWrapper";
import { useClickOutside } from "webrix/hooks";
import { useHistory } from "react-router-dom";
import Button from "components/global/Button";

const Wrapper = styled.div`
  width: 240px;
  max-width: 240px;
  max-height: 202px;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  left: ${({ top }) => (top ? "24px" : "80%")};
  top: ${({ top }) => (top ? "" : "-50px")};
  z-index: 20;
  background: #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05), 0px 25px 35px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  color: var(--grey_1);
  padding: 12px 0;

  /* &::-webkit-scrollbar {
    display: initial;
    width: 4px;
    margin-right: 5px;
  }
  &::-webkit-scrollbar-track {
    background: var(--background);
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--grey_5);
    border-radius: 100px;
  } */

  .title {
    font-weight: 450;
    font-size: 12px;
    color: var(--body_text);
    padding: 0 12px;
  }

  /* .item-name {
    max-width: 140px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  } */

  .list {
    padding: 13px 15px;
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 9px;

    &:hover {
      cursor: pointer;
      background: var(--off_white);
    }
  }

  .check-container {
    width: 20px;
  }

  .name-container {
    display: flex;
    gap: 7px;
    align-items: center;
  }

  .imgWrapper {
    color: #fff;
  }

  .addWorkspaceWrapper {
    padding-inline: 12px;

    .noBorder {
      padding: 0;

      &:hover {
        background-color: transparent;
        color: var(--secondary);
      }
    }
  }

  @media screen and (max-width: 768px) {
    left: ${({ top }) => (top ? "24px" : "40%")};
  }
`;

const DropdownList = ({
  title,
  setShowDropdownList,
  top,
  list,
  lastListElementRef,
  defaultSelected,
  callback,
  user,
  user_accounts,
}) => {
  const history = useHistory();
  const [selected, setSelected] = useState(defaultSelected);
  const handleOnMouseDownCapture = useClickOutside(() => {
    setShowDropdownList(false);
  });

  const handleClick = (item) => {
    setSelected(item);
    callback(item);
    setShowDropdownList(false);
  };

  const userHasWorkspace = user_accounts?.find(
    (account) => account.owner.id === user.id
  );

  return (
    <Wrapper
      onMouseDownCapture={handleOnMouseDownCapture}
      top={top}
      className="sidebar-dropdown-tour"
    >
      <header className="title">{title}</header>
      <Spacer y={1.2} />

      <ul>
        {list.map((item, idx) => (
          <li
            className="list"
            onClick={() => handleClick(item)}
            key={item.id}
            ref={list.length === idx + 1 ? lastListElementRef : null}
          >
            <div className="check-container">
              {selected?.id === item.id && <img src={Check} alt="check" />}
            </div>
            <div className="name-container">
              <ImgWrapper size={2.4} imgHeight={"100%"} className="imgWrapper">
                {item.avatar ? (
                  <img src={item?.avatar} alt="brand" />
                ) : (
                  <span className="colorWhite textSmall upperCase">
                    {item.name?.charAt(0)}
                    {item.name?.charAt(1)}
                  </span>
                )}
              </ImgWrapper>
              <p className="item-name">{item.name}</p>
            </div>
          </li>
        ))}
      </ul>

      {!userHasWorkspace && title === "List of Workspaces" && (
        <div className="addWorkspaceWrapper">
          <Button
            text="Add my workspace"
            icon={plus}
            className="noBorder"
            color="var(--secondary)"
            onClick={() => history.push("/welcome")}
          />
        </div>
      )}
    </Wrapper>
  );
};

export default DropdownList;
